import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Icon, Input, Menu, Dropdown, Modal, Confirm } from 'semantic-ui-react';
import { showLoading, hideLoading, showMessage, hideMessage, getProducts } from '../actions';
// import { serverURI, ViewList } from '../config';
// import _ from 'lodash';

const request = require('superagent');

class ProductMenu extends Component {
    constructor(props) {
        super(props);
        props.getProducts();
    }

    handleCategoryClick(name, e) {
        console.log(name);
        // this.props.history.push('/' + name.replace(/ /g, '_'));
        // this.props.showLoading('Loading . . . ');
        this.props.history.push('/products/' + name);
    }

    render() {
        const { products, selectedCat } = this.props.product;

        return (
            <Fragment>
                <Menu fixed='left' vertical style={{ marginTop: '5em', marginLeft: '0em' }}>
                {
                    products.map((cat) => {
                        if (cat.sub_cat) {
                            return (
                                <Menu.Item key={cat.name}>
                                    <Menu.Header>{cat.name}</Menu.Header>
                                    <Menu.Menu>
                                    {
                                        cat.sub_cat.map((sub) => (
                                          <Menu.Item key={sub} name={sub} active={selectedCat === sub} onClick={this.handleCategoryClick.bind(this, sub)} disabled={(selectedCat === sub) || (sub === 'Offset Booklet')} />
                                        ))
                                    }
                                    </Menu.Menu>
                                </Menu.Item>
                            )
                        } else {
                            return (
                                <Menu.Item key={cat.name} name={cat.name} active={selectedCat === cat.name} onClick={this.handleCategoryClick.bind(this, cat.name)} disabled={(selectedCat === cat.name) || (cat.name === 'Offset Booklet')} />
                            )
                        }
                    })
                }
                </Menu>
            </Fragment>
        )
    }
}

const mapStateToProps = ({ product }) => {
    return { product }
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        showLoading: showLoading,
        hideLoading: hideLoading,
        showMessage: showMessage,
        hideMessage: hideMessage,
        getProducts: getProducts,
        // changeProductCat: changeProductCat,
        // changeProductSort: changeProductSort,
        // fetchProductCat: fetchProductCat,
        // getProducts: getProducts,
        // getProductImages: getProductImages,
        // exportProducts: exportProducts,
        // resetDownloadURL: resetDownloadURL
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(ProductMenu);
